import script from "./ProjectViewType.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectViewType.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectViewType.vue?vue&type=style&index=0&id=53f5d035&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f5d035"]])

export default __exports__